import React from 'react';

import { Button, Heading, Icon, Stack, Text } from '@eluve/components';

import { useChat } from './ConversationContextProvider';

interface ConversationCompletedProps {
  providerName?: string;
}

export const ConversationCompleted: React.FC<ConversationCompletedProps> = (
  props,
) => {
  const { isCompleted } = useChat();
  if (!isCompleted) return null;
  return (
    <Stack className="bg-white p-8 pt-32" align="center" gap={2} fullHeight>
      <Stack
        className="mb-4 size-14 rounded-full bg-[#3fa378] text-white"
        fullWidth={false}
        align="center"
        justify="center"
      >
        <Icon name="Check" size="xl" />
      </Stack>
      <Heading size="3xl">Thank you!</Heading>
      <Text>
        {props.providerName && <>{props.providerName} will see you soon</>}
      </Text>
      <Stack className="grow" fullWidth={false} align="center" justify="center">
        <Button onClick={() => window.close()}>
          <Icon name="X" size="auto" />
          Close Window
        </Button>
      </Stack>
    </Stack>
  );
};
